'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('redirectToAuthZeroService',
function($location, $window, cookieService, languageService) {

  return {
    toLoginPage: function(stateParams) {
          let returnToLocation = decodeURIComponent(stateParams.r).replaceAll('?', '&');

          if(returnToLocation.includes('p.profileEN')) {
            returnToLocation = returnToLocation.replace('p.profileEN', 'p.profile');
          } else if(returnToLocation.includes('p.profileFR')) {
            returnToLocation = returnToLocation.replace('p.profileFR', 'p.profile');
          }

          cookieService.setAuthCallbackDestination(returnToLocation);

          cookieService.removeCookie('signup');
          languageService.checkLanguageURLParam(returnToLocation);

          $window.location.href = $location.protocol() + '://' + $location.host() + '/auth/';
      
    }
  };
});
